// @flow
import React, { Component } from "react";
import _ from "lodash";
import styles from "./Box.scss";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { LocaleLink } from "../../common/";

const Box = (props: Object) => {
  const { data, readNotification } = props;
  const message = data ? data[`message_${Helper.getLang()}`] : "";

    const duration = data.created_at
        ? moment.duration(
              moment().diff(data.created_at)
          )
        : "";
    let val = moment(data.created_at).format(
        "MMM DD h:mm:ss a"
    );
    const hours = duration && duration.asHours();
    if (Number(hours) < 24) {
        val = I18n.getText("notification.hrs-ago", {
            hours: Math.round(Number(hours))
        });
    }
    if (Number(hours) < 1) {
        const minutes = duration && duration.asMinutes();
        val = I18n.getText("notification.minutes-ago", {
            minutes: Math.round(Number(minutes))
        });
    }

  return (
    <a
      onClick={() =>
        readNotification(data.id_notification, data.directs_to_link)
      }
    >
      <div className={styles.item}>
        <p className={styles.msg}>{message}</p>
        <p className={styles.createdAt}>{val}</p>
      </div>
    </a>
  );
};

export default Box;



// WEBPACK FOOTER //
// ./src/components/notifications/box/Box.js